<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 2px !important;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.flex {
  display: flex !important;
  width: 100%;
}

.flex-warp {
  flex-wrap: wrap;
}

.ivu-mr,
.ivu-mr-16 {
  margin-right: 2px !important;
}
.ivu-mt,
.ivu-mt-16 {
  margin-top: 2px !important;
}
.mr1 {
  margin-right: 5px;
  word-wrap: +break-word;
  word-break: +norm;
}
.flexs {
  display: flex !important;
  width: 20%;
}
//  需要改某一个 样式    equipment 下面的 子 el-form-item__label
.equipment .el-form-item__label {
  line-height: 22px;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card"
    v-loading="loading_export"
    element-loading-text="拼命导出中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="l-table-place">

      <div class="flex items-center justify-between ivu-mt">
        <div class="flex items-center">
          <p>场所类型：</p>
          <el-row>
            <el-button type="info" :class="{active:search_data.type==''?true:false}" plain @click="placetype(1)" v-model="search_data.type">全部</el-button>
            <el-button type="info" :class="{active:search_data.type==item.id?true:false}" plain v-for="item in place_type_list" :key="item.id" @click="placetype(item.id)" v-model="search_data.type">{{item.name}}</el-button>
          </el-row>
        </div>
      </div>

      <div class="flex flex-warp">
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">隐患描述</p>
          <el-input placeholder="请输入隐患描述" v-model="search_data.legacy_name" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">验收标准</p>
          <el-input placeholder="请输入验收标准" v-model="search_data.legacy_name" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">场所名称</p>
          <el-input placeholder="请输入场所名称" v-model="search_data.name" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">网格名称</p>
          <el-input placeholder="请输入网格名称" v-model="search_data.network" class="input-with-select" style="width: 76%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属街道</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.street_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in street_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属社区</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.community_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in community_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">场所状态(要先选场所类型)</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.management_state" placeholder="全部" clearable  @change="changes">
              <el-option 
                v-for="(item, index) in MANAGEMENT"
                :key="index"
                :label="item"
                :value="index"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">督导状态</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.supervision_state" placeholder="全部" clearable @change="changes">
              <el-option v-for="(item, index) in SUPERVISION" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">现场整改</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.supervision_state" placeholder="全部" clearable @change="changes">
              <el-option v-for="(item, index) in SUPERVISION" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </div>
        </div>
             <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">预审状态</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.supervision_state" placeholder="全部" clearable @change="changes">
              <el-option v-for="(item, index) in SUPERVISION" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </div>
        </div> -->

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">日期</p>
          <div class="l-show-more-search" style="width: 76%;">
            <el-date-picker v-model="value2" type="daterange" autocomplete="off" @blur="onPick(false)" clearable value-format="yyyy-MM-dd" start-placeholder="请选择有效起始时间" end-placeholder="请选择有效结束时间" @change="onPick(false)">
            </el-date-picker>
          </div>
        </div>

      <!-- </div> -->
    </div>

    <div class="l-primary l-table-config" style=" border-bottom: solid 1px #e4e7ed;">
      <el-popover placement="bottom-start" width="200" trigger="click" popper-class="l-table-column-fixed-select-box">
        <span slot="reference">
          <i class="el-icon-setting"></i>表格列表配置
        </span>
        <span slot="reference" @click="placeAccount" style="margin: 100px;">
          <i class="el-icon-upload2"> 导出隐患明细（隐患不合并，每一行一处隐患，带隐患图片连接）</i>
        </span>

        <div class="">
          <div class="l-flex l-flex-just-between" style="margin-bottom:10px">
            <div>
              表格列表配置
              <i class="el-icon-refresh-left" style="float:right;  color: red;margin: 3px;" @click="resetFixedCheck">重置</i>
            </div>
          </div>
          <el-divider class="l-table-column-fixed-title-divider"></el-divider>
          <el-checkbox-group v-model="fixed_list">
            <div v-for="(item,index) in columns" :key="index">
              <el-checkbox :label="item.prop" style="margin-bottom:4px">
                {{item.label}}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </el-popover>

      <div style="float: right;" @click="search_visible = true">
        <span>
          <i class="el-icon-search"></i>
          高級搜索
        </span>
      </div>
    </div>
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>
    <l-table :data="data" v-loading="loading" row-key="id">
      <el-table-column v-for="(item, index) in columns" :key="index" v-bind="{ ...item }" :label="item.label" show-overflow-tooltip>
        <template v-slot="{ row }">
          <!-- <template v-if="item.prop == 'state'">
            <el-tag type="success" disable-transitions>{{ MANAGEMENT[row.state] }}</el-tag>
          </template>
          -->
          <template v-if="item.prop == 'name'">
            <a style="color: #0C87FF;" @click="placeInfo(row.place_id)"> {{ row.name}}</a>

          </template>
          <template v-else-if="item.prop == 'pretrial_state'">
            {{ PERTRIAL_STATE[row.pretrial_state] }}
          </template>
          <template v-else-if="item.prop == 'danger_lavel'">
            <el-tag type="danger" size="small" disable-transitions>{{ LEVEL[row.danger_lavel] }}</el-tag>
          </template>
          <template v-else>
            {{ row[item.prop] }}
          </template>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="250" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="place_info_btn" @click="showInfo(row.hidden_id)"><i class="el-icon-edit"></i>详情</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="primary" auth="resource_edit_btn" @click="showEdit(row.hidden_id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="resource_del_btn" @click="del(row.hidden_id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>

        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>
    <!--高级搜索-->
    <el-drawer title="更多搜索" class="l-search-drawer" :modal="false" :visible.sync="search_visible" size="400px" :append-to-body="false" :modal-append-to-body="false" z-indx="-1">
      <div class="l-search-drawer-body">

        <el-form label-width="80px" ref="search_form" :model="search_data">

          <el-form-item label="隐患描述" prop="legacy_name">
            <el-input v-model="search_data.legacy_name" placeholder="请输入隐患描述"></el-input>
          </el-form-item>
          <el-form-item label="验收标准" prop="legacy_name">
            <el-input v-model="search_data.legacy_name" placeholder="请输入验收标准"></el-input>
          </el-form-item>
          <el-form-item label="场所名称" prop="name">
            <el-input v-model="search_data.name" placeholder="请输入场所名称"></el-input>
          </el-form-item>
          <el-form-item label="网格名称" prop="network">
            <el-input v-model="search_data.network" placeholder="请输入网格名称"></el-input>
          </el-form-item>
          <el-form-item label="所属街道" prop="street_name">
            <el-select v-model="search_data.street_id" placeholder="全部" clearable>
              <el-option v-for="item in street_list" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属社区" prop="community_name">
            <el-select v-model="search_data.community_id" placeholder="全部" clearable>
              <el-option v-for="item in community_list" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="督导状态" prop="supervision_state">
            <el-select v-model="search_data.supervision_state" placeholder="全部" clearable>
              <el-option v-for="(item, index) in SUPERVISION" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="现场整改" prop="supervision_state">
            <el-select v-model="search_data.supervision_state" placeholder="全部" clearable>
              <el-option v-for="(item, index) in SUPERVISION" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预审状态" prop="supervision_state">
            <el-select v-model="search_data.supervision_state" placeholder="全部" clearable>
              <el-option v-for="(item, index) in SUPERVISION" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="隐患分级" prop="supervision_state">
            <el-select v-model="search_data.supervision_state" placeholder="全部" clearable>
              <el-option v-for="(item, index) in SUPERVISION" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="复查结果" prop="supervision_state">
            <el-select v-model="search_data.supervision_state" placeholder="全部" clearable>
              <el-option v-for="(item, index) in SUPERVISION" :key="index" :label="item" :value="index"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业筛选" prop="industry_name">
            <el-select v-model="search_data.industry_id" placeholder="全部" clearable>
              <el-option v-for="item in industry_list" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选" prop="value2">
            <div class="l-show-more-search" style="width: 76%;">
              <el-date-picker v-model="value2" type="daterange" autocomplete="off" @blur="onPick(false)" clearable value-format="yyyy-MM-dd" start-placeholder="请选择有效起始时间" end-placeholder="请选择有效结束时间" @change="onPick(false)">
              </el-date-picker>
            </div>
          </el-form-item>

        </el-form>
      </div>

      <div class="l-search-drawer-footer">
        <el-button type="normal" @click="onReset">重置</el-button>
        <el-button type="primary" @click="onSearch">搜索</el-button>
      </div>
    </el-drawer>

    <!--详情-->
    <l-dialog :visible.sync="info_visible" title="隐患信息" width="1600px">
      <l-hidden-info :visible.sync="info_visible" :id="info_id" is-info />
    </l-dialog>

  </el-card>
</template>
<script>
import { LEVEL } from '../rental/rental';
import { SUPERVISION } from "@/common/constants/place";
import { PERTRIAL_STATE } from "./hidden";
// import { dateToStr,time_pick2 } from "@/utils/Fuc";
import PlaceInfo from "../place/Info.vue";
import Vue from "vue";
import Info from "./Info";
export default {
  components: {
    [PlaceInfo.name]: PlaceInfo,
    [Info.name]: Info,
  },
  data() {
    return {
      value1: '',
      data: [],
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      loading: false,
      loading_export: false,
      change_state_loading: [],

      add_visible: false, //是否显示添加
      info_visible: false, //是否显示编辑
      edit_visible: false, //是否显示编辑
      place_info_visible: false,
      edit_id: 0,
      info_id: 0,
      place_id: 0,
      place_type_list: [],
      community_list: [],
      street_list: [],
      industry_list: [
        { "id": 1, "name": "行业" }
      ],

      SUPERVISION: SUPERVISION,
      LEVEL: LEVEL,
      PERTRIAL_STATE: PERTRIAL_STATE,
      // 状态
      MANAGEMENT: [],
      //搜索
      search_visible: false,
      search_data: {
        name: "",
        charge: "",
        network: "",
        legacy_name: "",
        place_type_id: '',
        community_id: '',
        street_id: '',
        hidden_state: '1',
        equipment_state: '',
        industry_id: '',
        check_state: '',
        supervision_state: '',
        management_state: '',
        owner_state: '',
        sign_for_state: '',
        review_state: '',
        start_time: '',
        end_time: '',
        sort_state: '1',
        sort: '1',
        type: '',
      },
      rel_search_data: {},
      show_more_search: false,
      value2: '',
      //默认
      re_fixed_list: ["index", "community_name", "place_sn", "name", "doorplate_address"],
      fixed_list: ["index", "community_name", "place_sn", "name", "doorplate_address"],
    };
  },
  computed: {
    columns() {
      let columns = [
        {
          prop: "index",
          label: "序号",
          fixed: true,
          width: "60",
        },
        {
          prop: "street_name",
          label: "所属街道",
          fixed: true,
          width: "100",
        },
        {
          prop: "community_name",
          label: "所属社区",
          fixed: true,
          Width: "80",
        },

        {
          prop: "place_sn",
          label: "场所编码",
          fixed: true,
          Width: "140",
        },
        {
          prop: "name",
          label: "场所名称",
          fixed: true,
          Width: "140",
        },
        {
          prop: "doorplate_address",
          label: "场所地址",
          fixed: true,
          width: "140",
        },
        {
          prop: "network",
          label: "所属网格",
          fixed: true,
          width: "100",
        },
        {
          prop: "danger_lavel",
          label: "隐患等级",
          fixed: true,
          width: "80",
        },
        {
          prop: "danger",
          label: "隐患描述",
          fixed: true,
          width: "80",
        },
        {
          prop: "rectification",
          label: "隐患整改",
          fixed: true,
          width: "80",
        },
        {
          prop: "pretrial_state",
          label: "预审状态",
          fixed: true,
          width: "100",
        },
        {
          prop: "created_at",
          label: "隐患时间",
          fixed: true,
          width: "140",
        },
        {
          prop: "created_uid_name",
          label: "排查员",
          fixed: true,
          width: "80",
        },
        {
          prop: "owner_at",
          label: "业主整改时间",
          fixed: true,
          width: "120",
        },
      ];

      let result = columns.map((item) => {
        const index = this.fixed_list.findIndex((itm) => {
          return itm == item.prop;
        });
        if (index != -1) {
          item.fixed = true;
          if (!item.width) {
            item.width = item.minWidth;
          }
        } else {
          if (item.minWidth && item.width) {
            delete item.width;
          }
          item.fixed = false;
        }

        return item;
      });

      return result;
    },
  },

  watch: {

    fixed_list(val) {
      if (val.length > 20) {
        this.fixed_list.shift();
      }
    },
  },

  mounted() {
    this.getList();
    this.getSearchData();
  },

  methods: {
      //导出
      placeAccount() {
      this.loading_export = true;
      this.$_invoke("hiddenDanger_export", { type:this.search_data.type,...this.rel_search_data})
        .then((ret) => {
          window.open(ret);
        })
        .catch((error) => {
          console.error(error);
          this.$_msg.error("导出失败 " + error);
        })
        .finally(() => {
          this.loading_export = false;
        });
    },

    //通过类型筛选
    placetype(id) {
      this.search_data.type = id;
      this.rel_search_data = this.search_data;
      this.getSearchData();
      this.getList();
    },
    changes() {
      this.rel_search_data = this.search_data;
      this.getList();
    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("hiddenDanger_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.search_data,
      })
        .then((ret) => {
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //
    placeInfo(id) {
      this.place_id = id;
      this.$nextTick(() => {
        this.place_info_visible = true;
      });
    },
    //获取搜索信息 

    getSearchData() {
      this.loading = true;
      this.$_invoke("place_getSearchData", {
        type: this.search_data.type
      })
        .then((ret) => {
          this.street_list = ret.street_list;
          this.community_list = ret.community_list;
          this.place_type_list = ret.place_type_list;
          this.MANAGEMENT = ret.place_state_list;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    //显示详情
    showInfo(id) {
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },
    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    //显示修改界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },

    //编辑成功回调
    onEditSucess() {
      this.edit_visible = false;
      this.getList();
    },
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`resource_delete`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList();
          });
        })
        .catch(() => { });
    },
    //默认时间
    // onfocus() {
    //   if (this.value2 == "" || !this.value2) {
    //     this.value2 = time_pick2();
    //   }
    // },
    //时间搜索
    onPick(cant) {
      if (!this.value2) {
        this.value2 = "";
        this.search_data.start_time = "";
        this.search_data.end_time = "";
      } else {
        this.search_data.start_time = this.value2[0];
        this.search_data.end_time = this.value2[1];
      }
      if (!cant) {
        this.onSearch();
      }
    },
    //重置固定栏位选择
    resetFixedCheck() {
      this.fixed_list = JSON.parse(JSON.stringify(this.re_fixed_list));
    },
  },
};
</script>
